import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { sourceAppSelector } from '../../app/selectors/contactUsSelector';
import { Severity } from '../presentationalComponents/Severity';
import { dispatchUpdateRequest, dispatchUpdateBusinessImpactConfirmed, dispatchCustomerAvailabilityConfirmed } from '../reduxUpdater/dispatchers/requestDispatchers';
import { isEmailFieldDisabledSelector, isSeverityEditingModeSelector } from '../reduxUpdater/selectors/commonSelectors';

const mapStateToProps = (state: IAppState) => {
  return {
    sourceApp: sourceAppSelector(state),
    isEmailFieldDisabled: isEmailFieldDisabledSelector(state),
    isSeverityEditingMode: isSeverityEditingModeSelector(state),
  };
};

const mapDispatchToProps = {
  dispatchUpdateRequest,
  dispatchUpdateBusinessImpactConfirmed,
  dispatchCustomerAvailabilityConfirmed,
};

export const SeverityContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Severity);
